import { NgModule } from '@angular/core';

import { AdminFilterPipe } from './admin-filter.pipe';
import { EncodeHTMLPipe } from './encode-html.pipe';
import { FileSizePipe } from './file-size.pipe';
import { RemoveHTMLTagsPipe } from './remove-html-tags.pipe';
import { SimpleFormatPipe } from './simple-format.pipe';
import { SourceNamePipe } from './source-name.pipe';

@NgModule({
  declarations: [
    AdminFilterPipe,
    EncodeHTMLPipe,
    FileSizePipe,
    RemoveHTMLTagsPipe,
    SimpleFormatPipe,
    SourceNamePipe,
  ],
  exports: [
    AdminFilterPipe,
    EncodeHTMLPipe,
    FileSizePipe,
    RemoveHTMLTagsPipe,
    SimpleFormatPipe,
    SourceNamePipe,
  ],
  providers: [RemoveHTMLTagsPipe],
})
export class PipesModule {}

export { AdminFilterPipe };
export { EncodeHTMLPipe };
export { FileSizePipe };
export { RemoveHTMLTagsPipe };
export { SimpleFormatPipe };
export { SourceNamePipe };
